import { flashMessage } from '../utils/flash.js'

export default () => {
  return (message, type = 'info') => flashMessage(message, type)
}
